import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import CompanyInfo from "components/CompanyInfo";
import usePathNavigate from "lib/hook/usePathNavigate";
import withAuth from "lib/hook/withAuth";

function RequestEstimatePass() {
    const { pathNavigate } = usePathNavigate();

    const onConfirm = () => {
        console.log("onConfirm");
        pathNavigate("/", { replace: true });
    };

    return (
        <Box>
            <Flex
                flexDirection="column"
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Image src="/assets/images/icn_circle_check.svg" mt={"73px"} />
                <Text mt="20px" fontSize={"22px"} fontWeight="semibold">
                    견적 요청 성공
                </Text>
                <Text
                    whiteSpace={"pre-wrap"}
                    mt="22px"
                    fontSize={"14px"}
                    lineHeight="22px"
                    textAlign="center"
                >
                    {
                        "영업일 기준 24시간 이내 확인해 드립니다.\n견적이 나오면 견적조회를 통해 주문하실 수 있어요."
                    }
                </Text>
                <Box w={"full"} px={"20px"} mt="20px" mb={"70px"}>
                    <Button
                        w={"full"}
                        h="50px"
                        colorScheme={"mint"}
                        mt="40px"
                        fontSize={"16px"}
                        fontWeight="semibold"
                        onClick={onConfirm}
                    >
                        확인
                    </Button>
                </Box>
            </Flex>
            <CompanyInfo />
        </Box>
    );
}

export default withAuth(RequestEstimatePass);
